// extracted by mini-css-extract-plugin
export var columnItem = "_fm-3";
export var columnItemDraggable = "_fm-5";
export var dragHandle = "_fm-0";
export var dragHandleHovered = "_fm-1";
export var dropdown = "_fm-6";
export var dropdownContent = "_fm-8";
export var dropdownInner = "_fm-7";
export var filterDropdownHeader = "_fm-9";
export var icon = "_fm-2";
export var moveToTopButton = "_fm-4";
export var sectionDivider = "_fm-a";